import React from 'react';
import PropTypes from 'prop-types';
import GridInput from './GridInput';

/**
 * Component to display the GridInput without somes choices
 * Filters the list of choices with a function
 */
class GridInputFilter extends React.Component {
  render() {
    const { choices, filter, ...rest } = this.props;

    // Filters choices with a function
    const filteredChoices = filter(choices);

    return <GridInput {...rest} choices={filteredChoices} />;
  }
}

GridInputFilter.propTypes = {
  /**
   * Function to filter
   */
  filter: PropTypes.func.isRequired,
  /**
   * All choices available
   */
  choices: PropTypes.arrayOf(PropTypes.object)
};

export default GridInputFilter;
